export default __webpack_public_path__ + "static/media/settings-outline.24b8dc2f.svg";